// extracted by mini-css-extract-plugin
export default {"wrapper":"Paragraph_wrapper__8pKUg","small":"Paragraph_small__PhHN2"};